import { Layout, theme } from 'antd';
import Footers from '../components/Footer';
import Headers from '../components/Header';
import Siders from '../components/Sider';
import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StafTable from '../components/Stafftable';
const { Content } = Layout;

const TableStaff = () => {
    const {
        token: { colorBgContainer },
    } = theme.useToken();
    
    return (
        <Layout
            style={{
                minHeight: '100vh',
            }}
        >
            <Siders />
            <Layout>
                <Headers />
                <Content
                    className="site-layout"
                    style={{
                        padding: '0 10px',
                        // height: '80vh'
                    }}
                >
                    <div
                        style={{
                            // padding: 24,
                            minHeight: 380,
                            background: colorBgContainer,
                        }}
                    >
                        <h1>Personal AZ</h1>
                        <br /><br />
                        <StafTable />
                    </div>
                </Content>
                <Footers />
            </Layout>
        </Layout>
    );
};

export default TableStaff;
